export default (clientHttp) => ({
  read(slug) {
    if (slug) {
      return clientHttp.get(`v1/user/houses/${slug}`)
    }

    return clientHttp.get('v1/user/houses')
  },
})
